import { useQueryClient, useMutation } from "@tanstack/react-query";
import { fetchPostQuery } from "../api";

// API POST request to send project to mdocs
export function useSendProjectToMdocs(id) {
  const url = `projekti/send-project-to-mdocs/${id}`;
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: async () => {
      return fetchPostQuery(url);
    },
    onSuccess: () => {
      queryClient.invalidateQueries(["project-status-naziv", id]);
    },
  });
}
